<template>
  <div class="dol-col" :style="style">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "dol-col",
  props: {
    span: {type: Number},
    flex: {type: Number},
    width: {type: String},
  },
  data() {
    return {};
  },
  computed: {
    style(){
      let style = {};
      if(this.width){
        style.width = this.width;
      }else{
        style.flex = this.span || this.flex;
      }
      return style;
    }
  },
}
</script>

<style lang="scss" scoped>
.dol-col {
  height: 100%;
  overflow-x: hidden;
  display: inline-block;
  margin: 0 10px;
  position: relative;
  overflow-y: auto;
}
</style>
